import PropTypes from "prop-types";
import React, { forwardRef } from "react";

import { PropTypeShapes } from "../../types";
import { disableWhenIos } from "../../utils/codeSplit";
import { getModifierKeysForEvent } from "../../utils/getModifierKeys";
import Icon from "../interface/Icon";

const onLeftElementsClick = (e, props) => {
  if (props.onLeftElementsClick) {
    props.onLeftElementsClick(props.clickContext);
    e.stopPropagation();
    e.preventDefault();
  }
};

const onRightElementsClick = (e, props) => {
  if (props.onRightElementsClick) {
    props.onRightElementsClick(props.clickContext, getModifierKeysForEvent(e));
    e.stopPropagation();
    e.preventDefault();
  }
};

const onMiddleElementsClick = (e, props) => {
  if (props.onMiddleElementsClick) {
    props.onMiddleElementsClick(props.clickContext);
    e.stopPropagation();
    e.preventDefault();
  }
};

const renderMiddleElements = useProps => {
  return useProps.text ? (
    <span>{useProps.text}</span>
  ) : useProps.middleElements ? (
    <div className="listItemMiddleElements" onClick={e => onMiddleElementsClick(e, useProps)}>
      {useProps.middleElements}
    </div>
  ) : null;
};

const renderLeftElements = useProps => {
  if (!useProps.leftElements) {
    return null;
  }
  return (
    <div className="listItemLeftElements" onClick={e => onLeftElementsClick(e, useProps)}>
      {useProps.leftElements}
    </div>
  );
};

const renderRightElements = useProps => {
  if (!useProps.rightElements) {
    return null;
  }
  return (
    <div className="listItemRightElements" onClick={e => onRightElementsClick(e, useProps)}>
      {useProps.rightElements}
    </div>
  );
};

const ListItemView = forwardRef((props, ref) => {
  let dragHandle;
  if (props.useDragHandle) {
    dragHandle = (
      <div className={`listItemGutter${props.canDrag ? "" : " disabled"}`}>
        <Icon icon="dragHandle" color="iconMid" />
      </div>
    );
  }

  return (
    <div
      ref={ref}
      className={`listItemView ${props.isSelected ? "selected" : ""} ${props.className ? props.className : ""}`}
      onClick={e => (props.onClick ? props.onClick(props.clickContext, getModifierKeysForEvent(e)) : null)}
      onDoubleClick={disableWhenIos(e =>
        props.onDoubleClick ? props.onDoubleClick(props.clickContext, getModifierKeysForEvent(e)) : null
      )}
    >
      {dragHandle}
      {renderLeftElements(props)}
      {renderMiddleElements(props)}
      {renderRightElements(props)}
    </div>
  );
});

ListItemView.displayName = "listItemView";

ListItemView.propTypes = {
  text: PropTypes.string,
  middleElements: PropTypeShapes.elementOrArray,
  leftElements: PropTypeShapes.elementOrArray,
  rightElements: PropTypeShapes.elementOrArray,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onMiddleElementsClick: PropTypes.func,
  onLeftElementsClick: PropTypes.func,
  onRightElementsClick: PropTypes.func,
  isSelected: PropTypes.bool.isRequired,
  clickContext: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  useDragHandle: PropTypes.bool,
  canDrag: PropTypes.bool
};

export default ListItemView;
